/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const bannerTokens = {
  ContainerBorderRadiusBaseDefault: '0px',
  ContainerSpacingInnerVerticalBaseDefault: '16px',
  ContainerSpacingInnerHorizontalBaseDefault: '16px',
  ContainerBackgroundColorNegativeDefault: '#f8d2d8',
  ContainerBackgroundColorInformationalDefault: '#eaf0f8',
  ContainerBackgroundColorStaffDefault: '#fcf0ee',
  ContainerBackgroundColorPositiveDefault: '#d6efec',
  ContainerBackgroundColorNoticeDefault: '#fcf0ee',
  ContainerFontColorBaseDefault: '#394040',
  LinkColorBaseDefault: '#1c2222',
  ContentSpacingOuterHorizontalBaseDefault: '16px',
  ContentTextFontColorBaseDefault: '#394040',
  ContentTitleSpacingBottomBaseDefault: '8px',
  ContentTitleFontColorBaseDefault: '#232b2b',
  CloseActionSizeBaseDefault: '20px',
  CloseActionColorBaseDefault: '#1c2222',
  CloseActionBackgroundColorBaseDefaultHover: '#c4c4c4',
  CloseActionBackgroundColorBaseDefaultDown: '#a7aaaa',
  CloseActionOutlineOffsetBaseKeyboardFocus: '0px',
  CloseActionOutlineStrokeBaseKeyboardFocus: '2px solid',
  CloseActionOutlineColorBaseKeyboardFocus: '#285da3',
} as const;
